import { GetUserType } from '@orbit/api-types'

/**
 * "First L." display name used in lists and rows where space is tight.
 * Falls back to first name only, then a generic placeholder. Accepts any object
 * carrying the two name fields (like `getInitials`) so non-user shapes can reuse it.
 */
export const getShortName = (
    member: Pick<GetUserType, 'firstName' | 'lastName'> | undefined,
): string => {
    if (!member) return 'Unknown'
    const first = member.firstName?.trim() ?? ''
    const last = member.lastName?.trim() ?? ''
    if (first && last) return `${first} ${last[0].toUpperCase()}.`
    if (first) return first
    if (last) return last
    return 'Member'
}

/**
 * Uppercase monogram from first/last name, trimming stray whitespace.
 * Accepts any object carrying the two name fields so non-user shapes
 * (e.g. trip-overview travelers) can reuse it. Falls back to `?`.
 */
export const getInitials = (
    member: Pick<GetUserType, 'firstName' | 'lastName'> | undefined,
): string => {
    if (!member) return '?'
    const first = member.firstName?.trim()[0] ?? ''
    const last = member.lastName?.trim()[0] ?? ''
    return (first + last).toUpperCase() || '?'
}
